<template>
    
    <div id="app" class="text-ch-blue" >

        <c-header v-if="isAuth" />

        <div class="h-0 
                    bg-gray-200 
                    flex 
                    rounded-cs-xl 
                    rounded-t-none 
                    relative z-10
                    overflow-hidden
                    transition-height
                    duration-300"

        :class="{

            'h-98': banner
            
        }"
        
        >

            <div class="h-full pt-20 flex-grow flex items-center justify-center" >

                <h1 class="text-4xl font-medium text-ch-blue" >
                    
                    <span class="text-ch-light-blue" >Manage</span> 
                    
                    your <br/> 
                    
                    {{ title }} 
                    
                    <span class="text-ch-light-blue" >in no time.</span>
                    
                </h1>

            </div>

            <div class="w-98 flex-grow bg-bottom bg-contain bg-no-repeat" style="background-image: url('/images/banner.png')" />

        </div>

        <div>

            <router-view v-slot="{ Component }" >

                <transition name="fade" mode="out-in" >

                    <component :is="Component" />

                </transition>

            </router-view>

        </div>

    </div>

</template>

<script>

    import './assets/css/main.css'

    import { useStore } from 'vuex'
    import { useRouter } from 'vue-router'
    import { ref, watch, computed, reactive, onMounted, onBeforeUnmount } from 'vue'

    import cHeader from './components/header.vue'

    export default {
    
        name: 'App',

        components: { cHeader },

        setup( props, context ) {

            const store = useStore()
            const route = useRouter().currentRoute

            const title = ref('animals')

            const isAuth = computed(() => store.getters.isAuth )
            const appBody = computed(() => store.state.properties.appBody )

            const appScrollTop = computed({
                get: () => store.state.properties.appScrollTop,
                set: val => store.commit( 'setAppScrollTop', val ) 
            })

            const preventScroll = computed({
                get: () => store.state.properties.preventScroll,
                set: val => store.commit( 'setPreventScroll', val )
            })

            // Banner

            const banner = computed({
                get: () => store.state.banner,
                set: val => store.commit( 'setBanner', val )
            })

            const bannerRoutesList = computed(() => store.state.bannerRoutesList )

            // Methods

            const getProperties = () => {

                store.commit( 'setAppBody', document.getElementsByTagName('html')[0] )

                window.addEventListener( 'scroll', getAppScrollTop )

            }

            const getAppScrollTop = () => {

                if ( preventScroll.value ) appBody.value.scrollTop = appScrollTop.value
                else store.commit( 'setAppScrollTop', appBody.value.scrollTop )

            }

            // Watchers

            watch( preventScroll, () => {

                if ( preventScroll.value ) appBody.value.style.overflow = 'hidden'
                else appBody.value.style.overflow = 'auto'

            }) 

            watch( route, () => {

                if ( bannerRoutesList.value.includes( route.value.name ) ) {

                    banner.value = true

                    if ( route.value.name === 'Appointments' ) title.value = 'animals'
                    else title.value = 'invoices'

                }

                else banner.value = false

            })

            // Life Hooks

            onMounted(() => {

                getProperties()

            })

            onBeforeUnmount(() => {

                window.removeEventListener( 'scroll', getAppScrollTop )

            })

            return {
                title,
                isAuth,
                banner,
                appBody,
                appScrollTop,
                preventScroll
            }

        }

    }

</script>
